import { Col, Form, Input, Row, Select } from "antd";
import { useTranslation } from "react-i18next";
import { IntegrationProtocol } from "../../../api/models";
import { SaveIntegrationButton } from "../actions/SaveIntegrationButton";

interface FormItemProps {
  formDisabled: boolean;
}

export const EmailFormItems = ({ formDisabled }: FormItemProps) => {
  const { t } = useTranslation();
  return (
    <div data-testid="email-form-items">
      <Row>
        <Col>
          <div
            style={{
              display: "flex",
              gap: "4em",
            }}
          >
            <Form.Item
              label={<b>{t("integrations:integration-name")}</b>}
              name="integrationName"
              rules={[{ required: true, message: t("translations:required") }]}
            >
              <Input style={{ width: "175px" }} disabled={formDisabled} />
            </Form.Item>
            <Form.Item
              label={<b>{t("integrations:integration-type")}</b>}
              name="integrationProtocol"
              rules={[{ required: true, message: t("translations:required") }]}
            >
              <Select style={{ width: "175px" }} disabled={formDisabled}>
                {Object.values(IntegrationProtocol).map((protocol) => (
                  <Select.Option key={protocol} value={protocol}>
                    {protocol}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
        </Col>
      </Row>
      <Form.Item
        label={<b>{t("integrations:endpoint-url")}</b>}
        style={{ flex: 1 }}
        name="endpointUrl"
        rules={[{ required: true, message: t("translations:required") }]}
      >
        <Input
          style={{ width: "100%", maxWidth: "415px" }}
          disabled={formDisabled}
          placeholder="recipient@example.com"
        />
      </Form.Item>
    </div>
  );
};
